export default "__VITE_ASSET__DElNG_oU__"